import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { User, Mail, Phone, MapPin, Lock, Camera, Save, Package, Heart, LogOut, Edit2, Plus, Trash2 } from 'lucide-react';
import Header from './components/Header22';
import Footer from './components/Footer22';

const Profile22 = () => {
    const navigate = useNavigate();
    const [activeTab, setActiveTab] = useState('profile');
    const [isEditing, setIsEditing] = useState(false);
    const [profileData, setProfileData] = useState({
        fullName: 'Priya Verma',
        email: 'priya.verma@example.com',
        phone: '+91 98765 43210',
        avatar: 'https://ui-avatars.com/api/?name=Priya+Verma&size=200&background=C4572A&color=FFFFFF&font-size=0.4',
        address: {
            street: '42 Artisan Lane',
            city: 'Jaipur',
            state: 'Rajasthan',
            pincode: '302001',
        },
        bio: 'Lover of handloom textiles and sustainable Indian fashion.',
    });

    const [addresses, setAddresses] = useState([
        {
            id: 1,
            label: 'Home',
            name: 'Priya Verma',
            street: '42 Artisan Lane, C-Scheme',
            city: 'Jaipur',
            state: 'Rajasthan',
            pincode: '302001',
            phone: '+91 98765 43210',
            isDefault: true,
        },
        {
            id: 2,
            label: 'Office',
            name: 'Priya Verma',
            street: '15 Craft Hub, Malviya Nagar',
            city: 'Jaipur',
            state: 'Rajasthan',
            pincode: '302017',
            phone: '+91 98765 43210',
            isDefault: false,
        },
    ]);

    const [passwordData, setPasswordData] = useState({
        currentPassword: '',
        newPassword: '',
        confirmPassword: '',
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        if (name.includes('.')) {
            const [parent, child] = name.split('.');
            setProfileData(prev => ({
                ...prev,
                [parent]: { ...prev[parent], [child]: value },
            }));
        } else {
            setProfileData(prev => ({ ...prev, [name]: value }));
        }
    };

    const handlePasswordChange = (e) => {
        const { name, value } = e.target;
        setPasswordData(prev => ({ ...prev, [name]: value }));
    };

    const tabs = [
        { key: 'profile', label: 'Profile', icon: User },
        { key: 'addresses', label: 'Addresses', icon: MapPin },
        { key: 'security', label: 'Security', icon: Lock },
    ];

    const inputStyle = {
        width: '100%',
        padding: '14px 16px',
        backgroundColor: '#FFFFFF',
        border: '1px solid #E8DDD0',
        borderRadius: '8px',
        fontSize: '14px',
        color: '#5C3D2E',
        outline: 'none',
        fontFamily: "'Source Sans 3', -apple-system, sans-serif",
        transition: 'border-color 0.3s ease',
    };

    const labelStyle = {
        display: 'block',
        fontSize: '13px',
        fontWeight: 600,
        color: '#5C3D2E',
        marginBottom: '6px',
    };

    return (
        <>
            <style>{`
                @import url('https://fonts.googleapis.com/css2?family=Cormorant+Infant:ital,wght@0,300;0,400;0,500;0,600;0,700;1,400&family=Source+Sans+3:wght@300;400;500;600;700&display=swap');

                .maati-profile-input:focus {
                    border-color: #C4572A !important;
                }
                .maati-profile-layout {
                    display: flex;
                    flex-direction: column;
                    gap: 32px;
                    max-width: 1100px;
                    margin: 0 auto;
                    padding: 120px 24px 80px;
                }
                @media (min-width: 768px) {
                    .maati-profile-layout {
                        flex-direction: row;
                        gap: 40px;
                    }
                }
            `}</style>

            <div style={{ minHeight: '100vh', backgroundColor: '#FAF6F1', fontFamily: "'Source Sans 3', -apple-system, sans-serif" }}>
                <Header />

                <div className="maati-profile-layout">
                    {/* Sidebar */}
                    <div style={{ width: '100%', maxWidth: '280px' }}>
                        <div style={{
                            backgroundColor: '#FFFFFF', borderRadius: '12px',
                            border: '1px solid #E8DDD0', padding: '28px',
                            textAlign: 'center', position: 'sticky', top: '100px',
                        }}>
                            {/* Avatar */}
                            <div style={{ position: 'relative', display: 'inline-block', marginBottom: '16px' }}>
                                <img
                                    src={profileData.avatar}
                                    alt={profileData.fullName}
                                    style={{
                                        width: '100px', height: '100px', borderRadius: '50%',
                                        objectFit: 'cover', border: '3px solid #F3ECE4',
                                    }}
                                />
                                <button style={{
                                    position: 'absolute', bottom: '0', right: '0',
                                    width: '32px', height: '32px', borderRadius: '50%',
                                    backgroundColor: '#C4572A', border: '2px solid #FFFFFF',
                                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                                    cursor: 'pointer', color: '#FFFFFF',
                                }}>
                                    <Camera size={14} />
                                </button>
                            </div>

                            <h3 style={{
                                fontFamily: "'Cormorant Infant', Georgia, serif",
                                fontSize: '22px', fontWeight: 600, color: '#5C3D2E', margin: '0 0 4px 0',
                            }}>
                                {profileData.fullName}
                            </h3>
                            <p style={{ fontSize: '13px', color: '#8B7355', margin: '0 0 20px 0' }}>
                                {profileData.bio}
                            </p>

                            {/* Navigation */}
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                                {tabs.map(tab => (
                                    <button
                                        key={tab.key}
                                        onClick={() => setActiveTab(tab.key)}
                                        style={{
                                            display: 'flex', alignItems: 'center', gap: '10px',
                                            padding: '12px 16px', borderRadius: '8px',
                                            border: 'none', cursor: 'pointer', width: '100%',
                                            backgroundColor: activeTab === tab.key ? '#FFF0EB' : 'transparent',
                                            color: activeTab === tab.key ? '#C4572A' : '#5C3D2E',
                                            fontFamily: "'Source Sans 3', sans-serif",
                                            fontSize: '14px', fontWeight: activeTab === tab.key ? 600 : 400,
                                            transition: 'all 0.2s ease',
                                        }}
                                    >
                                        <tab.icon size={18} /> {tab.label}
                                    </button>
                                ))}

                                <div style={{ height: '1px', backgroundColor: '#E8DDD0', margin: '8px 0' }} />

                                <button
                                    onClick={() => navigate('/template22/orders')}
                                    style={{
                                        display: 'flex', alignItems: 'center', gap: '10px',
                                        padding: '12px 16px', borderRadius: '8px',
                                        border: 'none', cursor: 'pointer', width: '100%',
                                        backgroundColor: 'transparent', color: '#5C3D2E',
                                        fontFamily: "'Source Sans 3', sans-serif", fontSize: '14px',
                                    }}
                                >
                                    <Package size={18} /> My Orders
                                </button>

                                <button
                                    onClick={() => navigate('/template22/shop')}
                                    style={{
                                        display: 'flex', alignItems: 'center', gap: '10px',
                                        padding: '12px 16px', borderRadius: '8px',
                                        border: 'none', cursor: 'pointer', width: '100%',
                                        backgroundColor: 'transparent', color: '#5C3D2E',
                                        fontFamily: "'Source Sans 3', sans-serif", fontSize: '14px',
                                    }}
                                >
                                    <Heart size={18} /> Wishlist
                                </button>

                                <div style={{ height: '1px', backgroundColor: '#E8DDD0', margin: '8px 0' }} />

                                <button
                                    onClick={() => navigate('/template22/login')}
                                    style={{
                                        display: 'flex', alignItems: 'center', gap: '10px',
                                        padding: '12px 16px', borderRadius: '8px',
                                        border: 'none', cursor: 'pointer', width: '100%',
                                        backgroundColor: 'transparent', color: '#D32F2F',
                                        fontFamily: "'Source Sans 3', sans-serif", fontSize: '14px',
                                    }}
                                >
                                    <LogOut size={18} /> Sign Out
                                </button>
                            </div>
                        </div>
                    </div>

                    {/* Main Content */}
                    <div style={{ flex: 1 }}>
                        {/* Profile Tab */}
                        {activeTab === 'profile' && (
                            <div style={{
                                backgroundColor: '#FFFFFF', borderRadius: '12px',
                                border: '1px solid #E8DDD0', padding: '32px',
                            }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '28px' }}>
                                    <h2 style={{
                                        fontFamily: "'Cormorant Infant', Georgia, serif",
                                        fontSize: '28px', fontWeight: 600, color: '#5C3D2E', margin: 0,
                                    }}>
                                        Personal Information
                                    </h2>
                                    <button
                                        onClick={() => setIsEditing(!isEditing)}
                                        style={{
                                            display: 'flex', alignItems: 'center', gap: '6px',
                                            padding: '8px 16px', borderRadius: '6px',
                                            border: '1px solid #E8DDD0', backgroundColor: 'transparent',
                                            color: '#C4572A', fontSize: '13px', fontWeight: 600,
                                            cursor: 'pointer', fontFamily: "'Source Sans 3', sans-serif",
                                        }}
                                    >
                                        <Edit2 size={14} /> {isEditing ? 'Cancel' : 'Edit'}
                                    </button>
                                </div>

                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
                                    <div>
                                        <label style={labelStyle}>Full Name</label>
                                        <input
                                            type="text" name="fullName"
                                            value={profileData.fullName}
                                            onChange={handleInputChange}
                                            disabled={!isEditing}
                                            className="maati-profile-input"
                                            style={{ ...inputStyle, backgroundColor: isEditing ? '#FFFFFF' : '#F3ECE4' }}
                                        />
                                    </div>
                                    <div>
                                        <label style={labelStyle}>Email</label>
                                        <input
                                            type="email" name="email"
                                            value={profileData.email}
                                            onChange={handleInputChange}
                                            disabled={!isEditing}
                                            className="maati-profile-input"
                                            style={{ ...inputStyle, backgroundColor: isEditing ? '#FFFFFF' : '#F3ECE4' }}
                                        />
                                    </div>
                                    <div>
                                        <label style={labelStyle}>Phone</label>
                                        <input
                                            type="tel" name="phone"
                                            value={profileData.phone}
                                            onChange={handleInputChange}
                                            disabled={!isEditing}
                                            className="maati-profile-input"
                                            style={{ ...inputStyle, backgroundColor: isEditing ? '#FFFFFF' : '#F3ECE4' }}
                                        />
                                    </div>
                                    <div>
                                        <label style={labelStyle}>Bio</label>
                                        <input
                                            type="text" name="bio"
                                            value={profileData.bio}
                                            onChange={handleInputChange}
                                            disabled={!isEditing}
                                            className="maati-profile-input"
                                            style={{ ...inputStyle, backgroundColor: isEditing ? '#FFFFFF' : '#F3ECE4' }}
                                        />
                                    </div>
                                </div>

                                <h3 style={{
                                    fontSize: '16px', fontWeight: 600, color: '#5C3D2E',
                                    margin: '28px 0 16px 0',
                                }}>
                                    Default Address
                                </h3>
                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
                                    <div>
                                        <label style={labelStyle}>Street</label>
                                        <input
                                            type="text" name="address.street"
                                            value={profileData.address.street}
                                            onChange={handleInputChange}
                                            disabled={!isEditing}
                                            className="maati-profile-input"
                                            style={{ ...inputStyle, backgroundColor: isEditing ? '#FFFFFF' : '#F3ECE4' }}
                                        />
                                    </div>
                                    <div>
                                        <label style={labelStyle}>City</label>
                                        <input
                                            type="text" name="address.city"
                                            value={profileData.address.city}
                                            onChange={handleInputChange}
                                            disabled={!isEditing}
                                            className="maati-profile-input"
                                            style={{ ...inputStyle, backgroundColor: isEditing ? '#FFFFFF' : '#F3ECE4' }}
                                        />
                                    </div>
                                    <div>
                                        <label style={labelStyle}>State</label>
                                        <input
                                            type="text" name="address.state"
                                            value={profileData.address.state}
                                            onChange={handleInputChange}
                                            disabled={!isEditing}
                                            className="maati-profile-input"
                                            style={{ ...inputStyle, backgroundColor: isEditing ? '#FFFFFF' : '#F3ECE4' }}
                                        />
                                    </div>
                                    <div>
                                        <label style={labelStyle}>Pincode</label>
                                        <input
                                            type="text" name="address.pincode"
                                            value={profileData.address.pincode}
                                            onChange={handleInputChange}
                                            disabled={!isEditing}
                                            className="maati-profile-input"
                                            style={{ ...inputStyle, backgroundColor: isEditing ? '#FFFFFF' : '#F3ECE4' }}
                                        />
                                    </div>
                                </div>

                                {isEditing && (
                                    <button
                                        onClick={() => setIsEditing(false)}
                                        style={{
                                            marginTop: '28px', padding: '14px 32px',
                                            backgroundColor: '#C4572A', color: '#FFFFFF',
                                            border: 'none', borderRadius: '8px',
                                            fontSize: '14px', fontWeight: 600, cursor: 'pointer',
                                            fontFamily: "'Source Sans 3', sans-serif",
                                            display: 'flex', alignItems: 'center', gap: '8px',
                                            transition: 'all 0.3s ease',
                                        }}
                                        onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#D4683B'; }}
                                        onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = '#C4572A'; }}
                                    >
                                        <Save size={16} /> Save Changes
                                    </button>
                                )}
                            </div>
                        )}

                        {/* Addresses Tab */}
                        {activeTab === 'addresses' && (
                            <div>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px' }}>
                                    <h2 style={{
                                        fontFamily: "'Cormorant Infant', Georgia, serif",
                                        fontSize: '28px', fontWeight: 600, color: '#5C3D2E', margin: 0,
                                    }}>
                                        Saved Addresses
                                    </h2>
                                    <button style={{
                                        display: 'flex', alignItems: 'center', gap: '6px',
                                        padding: '10px 20px', backgroundColor: '#C4572A',
                                        color: '#FFFFFF', border: 'none', borderRadius: '8px',
                                        fontSize: '13px', fontWeight: 600, cursor: 'pointer',
                                        fontFamily: "'Source Sans 3', sans-serif",
                                    }}>
                                        <Plus size={16} /> Add Address
                                    </button>
                                </div>

                                <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                                    {addresses.map(addr => (
                                        <div key={addr.id} style={{
                                            backgroundColor: '#FFFFFF', borderRadius: '12px',
                                            border: addr.isDefault ? '2px solid #C4572A' : '1px solid #E8DDD0',
                                            padding: '24px',
                                        }}>
                                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '12px' }}>
                                                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                                    <span style={{
                                                        padding: '4px 12px', borderRadius: '20px',
                                                        backgroundColor: '#F3ECE4', fontSize: '12px',
                                                        fontWeight: 600, color: '#5C3D2E',
                                                    }}>
                                                        {addr.label}
                                                    </span>
                                                    {addr.isDefault && (
                                                        <span style={{
                                                            padding: '4px 12px', borderRadius: '20px',
                                                            backgroundColor: '#FFF0EB', fontSize: '12px',
                                                            fontWeight: 600, color: '#C4572A',
                                                        }}>
                                                            Default
                                                        </span>
                                                    )}
                                                </div>
                                                <div style={{ display: 'flex', gap: '8px' }}>
                                                    <button style={{
                                                        background: 'none', border: 'none', cursor: 'pointer',
                                                        color: '#8B7355', padding: '4px',
                                                    }}>
                                                        <Edit2 size={16} />
                                                    </button>
                                                    <button style={{
                                                        background: 'none', border: 'none', cursor: 'pointer',
                                                        color: '#8B7355', padding: '4px',
                                                    }}>
                                                        <Trash2 size={16} />
                                                    </button>
                                                </div>
                                            </div>
                                            <p style={{ fontSize: '15px', fontWeight: 500, color: '#5C3D2E', margin: '0 0 4px 0' }}>
                                                {addr.name}
                                            </p>
                                            <p style={{ fontSize: '14px', color: '#8B7355', margin: '0 0 4px 0', lineHeight: 1.5 }}>
                                                {addr.street}<br />
                                                {addr.city}, {addr.state} {addr.pincode}
                                            </p>
                                            <p style={{ fontSize: '13px', color: '#8B7355', margin: 0 }}>
                                                {addr.phone}
                                            </p>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}

                        {/* Security Tab */}
                        {activeTab === 'security' && (
                            <div style={{
                                backgroundColor: '#FFFFFF', borderRadius: '12px',
                                border: '1px solid #E8DDD0', padding: '32px',
                            }}>
                                <h2 style={{
                                    fontFamily: "'Cormorant Infant', Georgia, serif",
                                    fontSize: '28px', fontWeight: 600, color: '#5C3D2E',
                                    margin: '0 0 8px 0',
                                }}>
                                    Change Password
                                </h2>
                                <p style={{ fontSize: '14px', color: '#8B7355', marginBottom: '28px' }}>
                                    Keep your account secure with a strong password
                                </p>

                                <div style={{ display: 'flex', flexDirection: 'column', gap: '20px', maxWidth: '500px' }}>
                                    <div>
                                        <label style={labelStyle}>Current Password</label>
                                        <input
                                            type="password" name="currentPassword"
                                            value={passwordData.currentPassword}
                                            onChange={handlePasswordChange}
                                            placeholder="Enter current password"
                                            className="maati-profile-input"
                                            style={inputStyle}
                                        />
                                    </div>
                                    <div>
                                        <label style={labelStyle}>New Password</label>
                                        <input
                                            type="password" name="newPassword"
                                            value={passwordData.newPassword}
                                            onChange={handlePasswordChange}
                                            placeholder="Enter new password"
                                            className="maati-profile-input"
                                            style={inputStyle}
                                        />
                                    </div>
                                    <div>
                                        <label style={labelStyle}>Confirm New Password</label>
                                        <input
                                            type="password" name="confirmPassword"
                                            value={passwordData.confirmPassword}
                                            onChange={handlePasswordChange}
                                            placeholder="Confirm new password"
                                            className="maati-profile-input"
                                            style={inputStyle}
                                        />
                                    </div>
                                    <button
                                        style={{
                                            padding: '14px 32px', backgroundColor: '#C4572A',
                                            color: '#FFFFFF', border: 'none', borderRadius: '8px',
                                            fontSize: '14px', fontWeight: 600, cursor: 'pointer',
                                            fontFamily: "'Source Sans 3', sans-serif",
                                            width: 'fit-content', transition: 'all 0.3s ease',
                                        }}
                                        onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#D4683B'; }}
                                        onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = '#C4572A'; }}
                                    >
                                        Update Password
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>
                </div>

                <Footer />
            </div>
        </>
    );
};

export default Profile22;
